import React from 'react'

import styled from 'styled-components';
import { InfoComponent } from './PatiendContactComponet/InfoComponent';
// import { ContactComponent } from './PatiendContactComponet/ContactComponent';
import { TitleHeader } from '../TitleHeader';


const Container = styled.div`
  width: 100%;
  margin-top: 2rem;
 
`

const Session = styled.div`
  width: 90%;
  background-color: #F9F9F9;
  margin: 0 auto;
  border-radius: 10px;
  box-shadow: 1px 1px 5px 1px #00000029;
 
`




// IMFORMACION DE PACIENTE -------------------------------




export const PatientContact = () => {
  

  return (
    <Container>
       <TitleHeader title='AGENDA TU CITA'/>
      <Session>
      
       {/* componente de informacion del paciente */}
       <InfoComponent/>
       {/* compoente de contacto del paciente */}
       {/* <ContactComponent/> */}

      </Session>
    </Container >
  )
}
